export interface IGetLimitedUsersResponse {
        id: number;
        name: string;
        range: number;
        latitude: number;
        longitude: number;
        key: string;
    }

    export class GetLimitedUsersResponse implements IGetLimitedUsersResponse {
        id: number;
        name: string;
        range: number;
        latitude: number;
        longitude: number;
        key: string;
    }